/**
 * @param {string} contentDispositionHeader
 * @return {null|string}
 */
export function getContentDispositionFileName(contentDispositionHeader) {
  if (!contentDispositionHeader || contentDispositionHeader.trim() === '') {
    return null
  }

  const matches = contentDispositionHeader.match(/.(?:filename=)(.*)/)
  if (!matches || matches.length < 2) {
    return null
  }

  return matches[1]
}
